export default "__VITE_ASSET__C6kBD2ob__"